import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import translations, { LOCALES } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "bigradap.locale";

export function LanguageProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    const nav = (navigator.language || "en").slice(0, 2);
    return translations[nav] ? nav : "en";
  });

  const setLocale = useCallback((code) => {
    if (!translations[code]) return;
    setLocaleState(code);
    if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, code);
  }, []);

  useEffect(() => {
    const meta = LOCALES.find((l) => l.code === locale) || LOCALES[0];
    document.documentElement.lang = locale;
    document.documentElement.dir = meta.dir;
  }, [locale]);

  const t = useCallback(
    (key) => {
      const dict = translations[locale] || translations.en;
      return dict[key] ?? translations.en[key] ?? key;
    },
    [locale]
  );

  const value = useMemo(
    () => ({ locale, setLocale, t, locales: LOCALES, dir: (LOCALES.find((l) => l.code === locale) || LOCALES[0]).dir }),
    [locale, setLocale, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
}

export { LOCALES };
